import { createAsyncThunk } from '@reduxjs/toolkit';
import { MonitorEntityViolationDto } from '@kortxio/hub-api';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { AsyncThunkConfig } from 'store/types';

export type GetMonitorViolationsArgs = {
  activeSince?: string;
};

export const getMonitorViolations = createAsyncThunk<
  MonitorEntityViolationDto[],
  GetMonitorViolationsArgs,
  AsyncThunkConfig
>(
  'monitoringViolations/getMonitorViolations',
  async ({ activeSince }, { dispatch, rejectWithValue }) => {
    try {
      const response =
        await api.monitorEntityViolation.getMonitorEntityViolations(
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          activeSince
        );

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);
